import { useSetRecoilState } from 'recoil';
import { uniqueId } from 'lodash';
import classNames from 'classnames';

import IcomoonIcon from 'components/common/Icon/IcomoonIcon';
import { dataDetailsCardTriggerState } from 'components/common/Managers/ViewStateManager.state';
import { FIELD_TYPE } from 'schemas';
import { FieldRenderer } from 'plugins/types';

import { TooltipPlacement, TruncateWithTooltip } from '../components';

import './EndpointFieldRenderer.scss';

export const EndpointFieldRenderer: FieldRenderer = ({ fieldId, row, schemaFields, value }) => {
  const endpointName = row['endpoint.name']?.toString() ?? '';
  const endpointOS = row['endpoint.os']?.toString();
  const endpointType = row['endpoint.type']?.toString();
  const iconKey = `${endpointType}-${endpointOS}`;
  const fieldIcon = schemaFields?.['endpoint.os'].icon;
  const icon = typeof fieldIcon === 'string' ? fieldIcon : fieldIcon?.[iconKey];
  const setDataDetailsFieldTrigger = useSetRecoilState(dataDetailsCardTriggerState);

  // only offer to open an endpoint details card if we have the required data
  const canShowDetails = !!row['agent.uuid'] && !!row['mgmt.url'];
  const clickHandler = !canShowDetails
    ? undefined
    : () => setDataDetailsFieldTrigger({ type: FIELD_TYPE.ENDPOINT, data: row });
  const endpointValuesClass = classNames('EndpointFieldRenderer__Values', {
    'EndpointFieldRenderer__Values--Linked': canShowDetails,
  });
  const endpointNameClass = classNames({ EndpointFieldRenderer__Name__Link: canShowDetails });
  const endpointUuidClass = classNames('EndpointFieldRenderer__UUID', {
    'EndpointFieldRenderer__UUID--Linked': canShowDetails,
  });

  return (
    <div className="EndpointFieldRenderer">
      {icon && (
        <span className="EndpointFieldRenderer__Icon">
          <IcomoonIcon name={icon} size={16} />
        </span>
      )}
      <div className={endpointValuesClass} onClick={clickHandler}>
        <span className="EndpointFieldRenderer__Name" data-term-field="endpoint.name" data-term-value-type="string">
          <TruncateWithTooltip
            id={uniqueId(`EndpointFieldRenderer-${value}-`)}
            text={endpointName}
            placement={TooltipPlacement.BOTTOM}
            classNames={endpointNameClass}
          />
        </span>
        <span className={endpointUuidClass} data-term-field={fieldId} data-term-value-type="string">
          <TruncateWithTooltip
            id={uniqueId(`EndpointFieldRenderer-${value}-`)}
            text={value?.toString() ?? ''}
            placement={TooltipPlacement.BOTTOM}
          />
        </span>
      </div>
    </div>
  );
};
